import React from 'react';
import { useSelector } from 'react-redux';
import {
  CURRENCY_MAPPING,
  FILTER_NAMES,
  FILTER_NAMES_STANDALONE,
  PRODUCT_VARIANT_ABBREVIATIONS,
} from '../../../shared/enums';
import { selectLocalizationData } from '../../features/localization/localizationSlice';
import {
  selectRegionalPricesData,
  selectRegionalPricesError,
} from '../../features/regionalPrices/regionalPricesSlice';
import {
  getCurrencyCode,
  getFilterPrice,
  getUnitPrice,
} from '../../features/regionalPrices/regionalPricesHelpers';

/**
 * @param page
 * @returns {null|JSX.Element}
 * @constructor
 */
const Microdata = ({ page }) => {
  const localization = useSelector(selectLocalizationData);
  const regionalPrices = useSelector(selectRegionalPricesData);
  const error = useSelector(selectRegionalPricesError);

  const images = {
    BB: 'https://mila-web-assets.s3.us-west-2.amazonaws.com/images/external/units/BB_Unit.jpeg',
    BS: 'https://mila-web-assets.s3.us-west-2.amazonaws.com/images/external/units/BS_Unit.jpeg',
    CC: 'https://mila-web-assets.s3.us-west-2.amazonaws.com/images/external/units/CC_Unit.jpeg',
    HW: 'https://mila-web-assets.s3.us-west-2.amazonaws.com/images/external/units/HW_Unit.jpeg',
    MB: 'https://mila-web-assets.s3.us-west-2.amazonaws.com/images/external/units/MB_Unit.jpeg',
    OR: 'https://mila-web-assets.s3.us-west-2.amazonaws.com/images/external/units/OR_Unit.jpeg',
    RP: 'https://mila-web-assets.s3.us-west-2.amazonaws.com/images/external/units/RP_Unit.jpeg',
  };

  const unitPrice = getUnitPrice(regionalPrices, page);
  const filterPrice = getFilterPrice(regionalPrices, page);
  const priceCurrency = getCurrencyCode(regionalPrices)
    || CURRENCY_MAPPING[localization.region]
    || CURRENCY_MAPPING.US;
  const image = images[page] || images[PRODUCT_VARIANT_ABBREVIATIONS.BASIC_BREATHER];
  const name = FILTER_NAMES[page] || FILTER_NAMES[PRODUCT_VARIANT_ABBREVIATIONS.BASIC_BREATHER];
  const description = FILTER_NAMES_STANDALONE[page]
    || FILTER_NAMES_STANDALONE[PRODUCT_VARIANT_ABBREVIATIONS.BASIC_BREATHER];
  const price = (unitPrice ?? 0) + (filterPrice ?? 0);

  return error ? null : (
    <span itemScope itemType='http://schema.org/Product' className='microdata'>
      <meta itemProp='image' content={image} />
      <meta itemProp='name' content={name} />
      <meta itemProp='description' content={description} />
      <span itemProp='offers' itemScope itemType='http://schema.org/Offer'>
        <meta itemProp='price' content={price} />
        <meta itemProp='priceCurrency' content={priceCurrency} />
      </span>
    </span>
  );
};

export default Microdata;
